import React from "react";
import styled from "styled-components";
import { UserIcon } from "ui/icons";
import { defaultThemeColors } from "ui/theme";
import { getAvatarUrl } from "utils";


export const Avatar = ({ profile, alt, size, onClick }) => {
    return <AvatarContainer size={size} onClick={onClick}>
        {profile ? (
            <img
                src={getAvatarUrl(profile)}
                alt={alt}
            />
        ) : (
            <UserIcon color="txt" />
        )}
    </AvatarContainer>
}

const AvatarContainer = styled.div`
    width: ${({ size = 70 }) => `${size}px`};
    height: ${({ size = 70 }) => `${size}px`};
    background-color: ${defaultThemeColors.inputBgNeutral};
    border-radius: 8px;
    object-fit: cover;
    overflow: hidden;
    display: flex;
    justify-content: center;
    cursor: pointer;
    align-items: center;

    & > svg {
        width: ${({ size = 70 }) => `${size / 2}px`};
        height: ${({ size = 70 }) => `${size / 2}px`};
        opacity: 0.5;
    }

    & > img {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
`;